import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getModeNavigationItems } from "@catchy/region-config";
import Bus from "@catchy/assets/svgs/nav/nav-bus.svg";
import Train from "@catchy/assets/svgs/nav/nav-train.svg";
import CableCar from "@catchy/assets/svgs/nav/nav-cablecar.svg";
import Ferry from "@catchy/assets/svgs/nav/nav-ferry.svg";
const MODE_VISUALS = {
  bus: {
    icon: Bus,
    activeColorText: "text-orange-400 dark:text-amber-400",
    hoverColorText: "text-amber-100 dark:text-zinc-800"
  },
  train: {
    icon: Train,
    activeColorText: "text-green-600 dark:text-green-400",
    hoverColorText: "text-green-50 dark:text-zinc-800"
  },
  cable_car: {
    icon: CableCar,
    activeColorText: "text-red-600 dark:text-red-400",
    hoverColorText: "text-red-50 dark:text-zinc-800"
  },
  ferry: {
    icon: Ferry,
    activeColorText: "text-blue-600 dark:text-blue-400",
    hoverColorText: "text-blue-50 dark:text-zinc-800"
  }
};
function ModeIcon(t0) {
  const $ = _c(2);
  const {
    icon
  } = t0;
  const Icon = icon;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon width="26" height="26" className="z-10 mb-0.5" aria-hidden="true" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default function ModeNavigation(t0) {
  const $ = _c(15);
  const {
    current,
    regionId
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== current || $[1] !== regionId) {
    const items = getModeNavigationItems(regionId);
    t3 = "Transport modes";
    t4 = "fixed bottom-0 left-0 z-20 w-full select-none bg-white text-sm font-semibold dark:bg-black";
    t1 = "m-auto flex w-full max-w-xl flex-row";
    let t5;
    if ($[6] !== current) {
      t5 = item => {
        const visual = MODE_VISUALS[item.mode];
        const isCurrent = current === item.id;
        if (!visual) {
          return null;
        }
        return <div className="pb-safe grid h-20 flex-1 place-items-center" key={item.id}><Link href={item.href} aria-label={item.label} aria-current={isCurrent ? "page" : undefined} className={`group relative flex w-full flex-col items-center focus:outline-none ${isCurrent ? visual.activeColorText : "text-zinc-700 dark:text-zinc-300"}`}><ModeIcon icon={visual.icon} /><div className="z-10 hidden text-center leading-none 3xs:block">{item.label}</div><svg viewBox="0 0 2 2" xmlns="http://www.w3.org/2000/svg" className={`absolute -top-3 z-0 w-12 transition-all ${visual.hoverColorText} ${isCurrent ? "opacity-100 dark:opacity-0 dark:group-hover:opacity-100 dark:group-focus:opacity-100 dark:group-active:opacity-100" : "opacity-0 group-hover:opacity-100 group-focus:opacity-100 group-active:opacity-100"}`}><circle cx="1" cy="1" r="1" fill="currentColor" /></svg></Link></div>;
      };
      $[6] = current;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t2 = items.map(t5);
    $[0] = current;
    $[1] = regionId;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <nav aria-label={t3} className={t4}>{t5}</nav>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}